<template>
  <div>
    <!-- Select Country -->
    <div class="form-group pl-3 col-sm-10">
      <label for="country_id">{{ $t('ct-country') }}</label>
      <select id="country_id" class="form-control" @change="e.remove('country_id')" v-model="business.country_id">
        <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
      </select>
      <small class="form-text text-danger" v-if="e.has('country_id')">{{ e.first('country_id') }}</small>
    </div>
    <!-- Input Business_name -->
    <div class="form-group">
      <label for="business_name" class="col-sm-2 control-label">{{ $t('ct-checkout-business-name') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="business_name" name="business_name" v-model="business.business_name" :class="{'is-invalid': e.has('business_name')}">
        <small class="form-text text-danger" v-if="e.has('business_name')">{{ e.first('business_name') }}</small>
      </div>
    </div>
    <!-- Input Contact_email -->
    <div class="form-group">
      <label for="contact_email" class="col-sm-2 control-label">{{ $t('ct-checkout-contact-email') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="contact_email" name="contact_email" v-model="business.contact_email" :class="{'is-invalid': e.has('contact_email')}">
        <small class="form-text text-danger" v-if="e.has('contact_email')">{{ e.first('contact_email') }}</small>
      </div>
    </div>
    <!-- Input Contact_phone -->
    <div class="form-group">
      <label for="contact_phone" class="col-sm-2 control-label">{{ $t('ct-checkout-contact-phone') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="contact_phone" name="contact_phone" v-model="business.contact_phone" :class="{'is-invalid': e.has('contact_phone')}">
        <small class="form-text text-danger" v-if="e.has('contact_phone')">{{ e.first('contact_phone') }}</small>
      </div>
    </div>

    <div class="col-sm-10">
      <button type="button" @click="saveBusiness" class="btn btn-success">{{ $t('ct-save') }}</button>
    </div>
  </div>
</template>

<script>
import {saveBussiness, getCountries} from '../../../../../js/services/integrations-internas/supercheckout';
import Errors from '../Util/errors'

export default {
  name: 'CheckoutBusinessInfo',
  props: ['auth'],
  data() {
    return {
      business: this.auth.business_info || {
        country_id: null,
        business_name: '',
        contact_email: '',
        contact_phone: '',
      },
      e: new Errors([]),
      countries: []
    };
  },
  methods: {
    saveBusiness() {
      this.e.clear()
      this.e.clearValidations()
      this.e.validation({
        country_id: 'required',
        business_name: 'required',
        contact_email: 'required|email',
        contact_phone: 'required',
      })

      if (!this.e.validate(this.business)) {
        return
      }

      saveBussiness(this.auth.token, this.business).then(({data}) => {
        this.$emit('input', data.business_information)
      })
    },
  },
  created() {
    getCountries(this.auth.token).then(({data}) => {
      this.countries = data.countries;

      if (!this.business.country_id) {
        this.business.country_id = data.detected.id;
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/CheckoutBusinessInfo.vue